export default "__VITE_ASSET__DXQXa31e__"